import React from 'react';
import {
  Typography,
  TextField
} from '@mui/material';

interface ReferenceComponentProps {
  referenceId: string;
  setReferenceId: (value: string) => void;
  validationError?: string;
  clearValidationError?: () => void;
}

const ReferenceComponent = ({referenceId, setReferenceId, validationError, clearValidationError}: ReferenceComponentProps) => {
    

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setReferenceId(event.target.value);
        // Clear validation error when user starts typing
        if (validationError && clearValidationError) {
            clearValidationError();
        }
    };

  return <>
    <Typography 
        variant="subtitle1" 
        sx={{ 
            fontWeight: 'medium',
            mb: 2,
            color: 'text.primary',
            fontSize: { xs: '1rem', md: '1.1rem' }
        }}
        >
        Reference ID or Unique ID
    </Typography>
    <TextField
        fullWidth
        placeholder="testrefID_1234"
        value={referenceId}
        onChange={handleInputChange}
        variant="outlined"
        error={!!validationError}
        helperText={validationError}
        sx={{ 
            mb: 3,
            '& .MuiOutlinedInput-root': {
            backgroundColor: 'white'
            }
        }}
        />
    
  </>;
}   
export default ReferenceComponent;